import React, { useState, useCallback, useMemo, useContext,useEffect } from "react";
import { Col, Container, Row, Card, CardBody, CardHeader } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb/BreadCrumb";
import TableContainerMin from "../../../Components/Common/TableContainer";
import { useQuery, useQueryClient } from "react-query";
import { DeleteOutlined, EditOutlined, EyeOutlined } from "@ant-design/icons";
import { Avatar, Button, Modal, Spin } from "antd";
import HistoryContext from "../../../Components/Hooks/HistoryContext";
import toast from "react-hot-toast";
import "../../Styles/style.css"
import { useTranslation } from "react-i18next"; ;
import { useNavigate } from "react-router-dom"; 
import vector1Icon from '../../../assets/images/Vector1.png';
import vectorStatut from '../../../assets/images/VectorStatut.png';
import { deleteFormulaire, getFormulaire } from "../services/formulaireApi";
import AddEditFormulaireForm from "../components/CreateEditFomulaire";

const Formulaires = (modal) => {
  const history = useContext(HistoryContext);
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  document.title = `Formulaire d'inspection | ${process.env.REACT_APP_NAME} - ${process.env.REACT_APP_DESCRIPTION}`;
  const [isAddEditModalOpen, setIsAddEditModalOpen] = useState(false);
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const [selectedFormulaire, setSelectedFormulaire] = useState(null);
  const [deleteConfirmModal, setDeleteConfirmModal] = useState(false);
  const [deleteTargetId, setDeleteTargetId] = useState(null);
  const [deleteTargetRegistrationNumber, setDeleteTargetRegistrationNumber] = useState("");
  const { isLoading, isError, error, data: formulaires=[] } = useQuery("formulaires", getFormulaire);
   const [isModalOpen, setIsModalOpen] = useState(false);
   const [isModalOpenExport, setIsModalOpenExport] = useState(false);
   const toggleModal = useCallback((formulaire = null) => {
  setSelectedFormulaire(formulaire);  
  setIsModalOpen(prev => !prev); 
}, []);

  const toggleModalExport = () => {
    setIsModalOpenExport(prev => !prev);
  };
  
  const toggleAddEditModal = useCallback((formulaire = null) => {
    setSelectedFormulaire(formulaire);
    setIsAddEditModalOpen(prev => !prev);
    if (isDetailModalOpen) setIsDetailModalOpen(false);
  }, [isDetailModalOpen]);

  const handleEdit = (formulaire) => {
    toggleAddEditModal(formulaire);
  };
  const toggleDetailModal = useCallback((formulaire = null) => {
    setSelectedFormulaire(formulaire);
    setIsDetailModalOpen(prev => !prev);
    if (isAddEditModalOpen) setIsAddEditModalOpen(false);
  }, [isAddEditModalOpen]);
  const handleDetail = (formulaireId) => {
    if(formulaireId){
      navigate(`/formulaires/detail/${formulaireId}`);
    }
  };
  const handleDelete = async (formulaireId) => {
    try {
      await deleteFormulaire(formulaireId);
      queryClient.invalidateQueries("formulaires");
      toast.success("Le formulaire a été supprimée avec succès 🎉");
    } catch (error) {
      console.error("Error deleting formulaire:", error);
      toast.error(`😔 Erreur lors de la suppression du formulaire : ${error?.message||error}`);
    } finally {
      setDeleteConfirmModal(false);
    }
  };
  const openDeleteConfirmModal = (formulaireId) => {
    const formulaireToDelete = formulaires.find(formulaire => formulaire.id === formulaireId);
    if (formulaireToDelete) {
      setDeleteTargetId(formulaireId);
      setDeleteTargetRegistrationNumber(formulaireToDelete.registrationNumber);
      setDeleteConfirmModal(true);
    }
  };
  const closeDeleteConfirmModal = () => {
    setDeleteConfirmModal(false);
  };
 
  
  const columns = useMemo(() => [
   
   
    {
      Header: () => (
      <div style={{ textAlign: "start", color:'#434343',fontSize:'14px',fontFamily:'Inter',fontWeight:'500px' }}>
         
         {t("formulaire.category")}
        </div>
      ),
      accessor: "category",
      Cell: ({ row }) => (
        <div style={{ textAlign: "start" }}>
          <span className="text-center" style={{color:'#434343',fontSize:'14px',fontFamily:'Inter',fontWeight:'400px'}}>
            {row.original?.category || "-"}
          </span>
        </div>
      ),
      filterable: false,
    },
       
    {
          Header: () => <div style={{ textAlign: "center" ,color:'#434343',fontSize:'14px',fontFamily:'Inter',fontWeight:'500px'}}>{t("formulaire.date")}</div>,
          accessor: "createdAt",
          Cell: ({ value }) => (
            <div style={{ textAlign: "center",color:'#434343',fontSize:'14px',fontFamily:'Inter',fontWeight:'400px' }}>
              {value ? new Date(value).toLocaleDateString('fr-FR') : "-"}
            </div>
          ),
          filterable: false,
        }, 
        {
            Header: () => <div style={{ textAlign: "end",color:'#434343',fontSize:'14px',fontFamily:'Inter',fontWeight:'500px' }}>{t("vehicle.actions")}</div>,
            accessor: "action",
            headerStyle: { textAlign: "text-center" },
            Cell: ({ row }) => (
              <div className="actions-cell">        
                <div
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "30px",
                    height: "30px",
                    backgroundColor: "#f5f5f5",
                    borderRadius: "50%",
                    boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)",
                    cursor: "pointer"
                  }}
                  onClick={() => toggleModal(row.original)} 
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="6" cy="12" r="2" fill="#151515" />
                    <circle cx="12" cy="12" r="2" fill="#151515" />
                    <circle cx="18" cy="12" r="2" fill="#151515" />
                  </svg>
                </div>
              </div>
            ),
            filterable: false,
          }
  ], [handleEdit, openDeleteConfirmModal, handleDetail]);
  const visibleColumnsCount = columns.length; 

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center", 
  },
  bigButton: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "5px 10px", // Réduit la taille du bouton
    backgroundColor: '#F6F6F6',
    color: "white",
    border: "none",
    borderRadius: "40px", // Légèrement arrondi mais plus petit
    cursor: "pointer",
    fontSize: "16px", // Taille réduite pour le texte
    position: "relative", // Pour contenir les onglets à l'intérieur
  },
  tabContainer: {
    display: "flex",
    gap: "5px", // Espacement réduit entre les onglets
    flexDirection: "row",
    
  },
  tabButton: {
    padding: "5px 16px", // Réduit la taille des onglets
    border: "none",
    borderRadius: "20px", // Onglets encore plus arrondis
    cursor: "pointer",
    fontSize: "14px", 
    transition: "background-color 0.3s",
    font:"Inter",
    fontWeight: "bold",
    backgroundColor: '#F6F6F6',

  },
};

// Filtrer les véhicules dont le statut est "En service"
const formulairesInInspectionType = formulaires.filter(formulaire => formulaire.category === 'inspectionCible');
const numberOfFormulairesInInspectionType = formulairesInInspectionType.length;
const formulairesInInspectionComplete = formulaires.filter(formulaire => formulaire.category === 'inspectionComplete');
const numberOfVehiclesInInspectionComplete = formulairesInInspectionComplete.length;
const formulairesInInspectionIncident = formulaires.filter(formulaire => formulaire.category === 'Incident');
const numberOfVehiclesInInspectionIncident = formulairesInInspectionIncident.length;

const renderTabs = () => (
  <div className="d-flex gap-3 mb-3">
    <div style={styles.container}>
      <button style={styles.bigButton}>
        <div style={styles.tabContainer}>
          {tabs.map((tab) => (
            <button
              key={tab}
              style={{
                ...styles.tabButton,
                backgroundColor: activeTab === tab ? "#151515" : "#F6F6F6",
                color: activeTab === tab ? "#FFFFFF" : "#595959", 
              }}
              onClick={() => handleTabChange(tab)}
            >
              {tab}
              {tab === 'Tout' && (
                <div
                  style={{
                    display: 'inline-flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '24px',
                    height: '24px',
                    borderRadius: '50%',
                    backgroundColor: activeTab === 'Tout' ? '#3D3D3D' : '#D9D9D9',
                    color: activeTab === 'Tout' ?  '#FFFFFF':'#595959', // Couleur de texte en fonction de l'état
                    fontSize: '12px', // Correction de la taille de police
                    marginLeft: '5px',
                  }}
                >
                  {formulaires?.length}
                </div>
              )}
              {tab === 'InspectionComplete' && (
                <div
                  style={{
                    display: 'inline-flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '24px',
                    height: '24px',
                    borderRadius: '50%',
                    backgroundColor: activeTab === 'InspectionComplete' ? '#3D3D3D' : '#D9D9D9', // Cercle blanc si actif, gris sinon
                       color: activeTab === 'InspectionComplete' ?  '#FFFFFF':'#595959',
                    fontSize: '12px',
                    marginLeft: '5px',
                  }}
                >
                  {numberOfVehiclesInInspectionComplete}
                </div>
              )}
              {tab === 'InspectionCible' && (
                <div
                  style={{
                    display: 'inline-flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '24px',
                    height: '24px',
                    borderRadius: '50%',
                    backgroundColor: activeTab === 'InspectionCible' ? '#3D3D3D' : '#D9D9D9', // Cercle blanc si actif, gris sinon
                    color: activeTab === 'InspectionCible' ?  '#FFFFFF':'#595959',
                    fontSize: '12px',
                    marginLeft: '5px',
                  }}
                >
                  { numberOfFormulairesInInspectionType}
                </div>
              )}
                {tab === 'Incident' && (
                <div
                  style={{
                    display: 'inline-flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '24px',
                    height: '24px',
                    borderRadius: '50%',
                    backgroundColor: activeTab === 'Incident' ? '#3D3D3D' : '#D9D9D9', // Cercle blanc si actif, gris sinon
                    color: activeTab === 'Incident' ?  '#FFFFFF':'#595959',
                    fontSize: '12px',
                    marginLeft: '5px',
                  }}
                >
                  { numberOfVehiclesInInspectionIncident }
                </div>
              )}
            </button>
          ))}
        </div>
      </button>
    </div>
  </div>
)
  const tabs = [t("formulaire.all"), t("formulaire.complet"), t("formulaire.cible"), t("formulaire.incident")];
  const [activeTab, setActiveTab] = useState('Tout');
  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };
  <div className="d-flex gap-3">{renderTabs()}</div>
  const navigate = useNavigate();
  const HeaderTable = () => (
<div className="gap-3">
    <div className="d-flex justify-content-between align-items-center w-100">
       
    <div className="d-flex gap-3">
      <strong style={{ fontSize: "24px" }}>
        {t("formulaire.formulaires")}
      </strong>
    </div>
    <div
      style={{
        display: "flex",
        alignItems: "center", 
        gap: "10px",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "30px",
          height: "30px",
          backgroundColor: "#f5f5f5",
          borderRadius: "50%",
          boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)",
          cursor: "pointer", 
        }}
        onClick={toggleModalExport}
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="6" cy="12" r="2" fill="#151515" />
          <circle cx="12" cy="12" r="2" fill="#151515" />
          <circle cx="18" cy="12" r="2" fill="#151515" />
        </svg>
      </div>
      <button
       className="buttonAdd"
        onMouseOver={(e) => (e.target.style.backgroundColor = ' #151515')}
        onMouseOut={(e) => (e.target.style.backgroundColor = ' #151515')}
        onClick={() => toggleAddEditModal(null)}
      >
        {t("formulaire.new")}
    
     
      </button>
    </div>
  </div>
  <div style={{ marginTop: "20px" }}></div> 
  {renderTabs()}
  </div>
 
  );
  const filteredFormulaires = useMemo(() => {
    if (!formulaires) return error?.message || [];
  
    let result = [];
    switch (activeTab) {
      case 'inspectionComplete':
        result = formulaires.filter(v => v.category === 'inspectionComplete');
        break;
      case 'inspectionCible':
        result = formulaires.filter(v => v.category === 'inspectionCible');
        break;
      case 'Incident':
        result = formulaires.filter(v => v.category === 'Incident');
        break;
      default:
        result = formulaires;
        break;
    }
  
    // Éliminer les doublons de catégories
    const uniqueCategories = [...new Set(result.map(v => v.category))];
  
    // Retourner les formulaires uniques basés sur les catégories
    return result.filter((v, index, self) => 
      uniqueCategories.includes(v.category) && 
      self.findIndex(f => f.category === v.category) === index
    );
  }, [formulaires, activeTab]);
  

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb page={t("formulaire.formulaires")}history={history} />
          <Row>
            <Col>
              <Card id="contactList">
                <CardHeader>
                  <HeaderTable />
                </CardHeader>
                <CardBody className="pt-0">
                  <TableContainerMin
                    columns={columns}
                    data={ filteredFormulaires}
                    isGlobalSearch={true}
                    isGlobalFilter={true}
                    customPageSize={10}
                    className="custom-header-css"
                    divClass="table-responsive table-card mb-3"
                    tableClass="align-middle table-nowrap"
                    theadClass="table-light"
                
                    HeaderTable={HeaderTable}
                  />
                  {isLoading && !isError && (
                    <div className="text-center">{t("global.loading")}
                      <Spin />
                    </div>
                  )}
                  { filteredFormulaires && filteredFormulaires.length === 0 && !isLoading && (
                    <div>{t("global.no-data-v")}</div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
          <AddEditFormulaireForm
            modal={isAddEditModalOpen}
            setModal={setIsAddEditModalOpen}
            toggle={toggleAddEditModal}
            selectedRole={selectedFormulaire}
          />
           <Modal
            title="Confirmer la suppression de ce véhicule"
            open={deleteConfirmModal}
            onCancel={closeDeleteConfirmModal}
          footer={[
                   <Button key="cancel" onClick={closeDeleteConfirmModal} className="bordered-btn-delete">
                  {t("global.no")}
                   </Button>,
                <Button key="delete" type="danger"  onClick={() => handleDelete(deleteTargetId)} className="bordered-btn">
                {t("global.yes")}
              </Button>,
  ]}
  width={400}
  style={{ top: 200 }} 
>
  <p>{t("vehicle.confirm_delete_vehicle")} {deleteTargetRegistrationNumber} ?</p>
</Modal>
<Modal

  visible={isModalOpenExport}
  onCancel={toggleModalExport}
  footer={null}
  width={261}
  height={120}
  radiuis={9.6} 
  border={0.96}
>
  <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
    <a
  onClick={() => {
    console.log("Exportation CSV...");
    toggleModalExport();
  }}
  style={{
    marginRight: '8px',
    fontFamily: "inter",
    fontWeight: '400px',
    fontSize: '14px', 
    color: "#252525",
    width: "100%",
    display: "flex",
    alignItems: "center" 
  }}
>
  <img src={vector1Icon} alt="Export en csv" style={{ marginRight: '8px' }} />
  <span>Exporter en CSV</span >
</a>

  </div>
</Modal>  
<Modal
  open={isModalOpen}
  onCancel={() => toggleModal()} 
  footer={null}
  width={206}
  height={10}
  radiuis={9.6} 
  border={0.96}
  
style={{top:'350px',right:'10px',position:'absolute'}}
 
>
<div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
    <a 
    onClick={() => handleDetail(selectedFormulaire?.id)}
      style={{
         display: "flex",
    alignItems: "center",
       marginRight:'8px',
      fontFamily:"inter",
      fontWeight:'400px',
        width: "100%",
        marginBottom: "16px" 
      }}
    >
    <EyeOutlined style={{ color: ' #898989',width:'20px' }}  />
     <span style={{size:'14px',color:" #252525"}} >Voir détails</span>
    </a>
    <a
  onClick={() => handleEdit(selectedFormulaire)}
  style={{
    marginRight: '8px',
    fontFamily: "inter",
    fontWeight: '400px',
    fontSize: '14px', 
    color: "#252525",
    width: "100%",
    display: "flex",
    marginBottom: "16px" 
  }}
>
      <EditOutlined style={{ color: ' #898989' }} />       
  <span style={{marginLeft:'10px'}} >Editer formulaire</span >
</a>
<a
  onClick={() => openDeleteConfirmModal(selectedFormulaire.id)}
  style={{
    marginRight: '8px',
    fontFamily: "inter",
    fontWeight: '400px',
    fontSize: '14px', 
    color: "#252525",
    width: "100%",
    marginBottom: "16px" 
    
  }}
>
<DeleteOutlined style={{ color: ' #898989' }} />     
  <span style={{marginLeft:'10px'}} >Archiver</span >
</a>

  </div>
</Modal>

</Container>
      </div>
    </React.Fragment>
  );
};

export default Formulaires;
